import DataPointRefund from "../../../components/units/DataPoint/Refund/DataPointRefund";

export default function DataPointRefundPage() {
  return <DataPointRefund />;
}
